/**
 * find parent component by name
 */
export default {
  data: function data() {
    return {
      parent: null
    };
  },
  methods: {
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          this.parent = parent;
          break;
        }

        parent = parent.$parent;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/mixins/find-parent.js
// module id = dX72
// module chunks = 176